import { useEffect, useState } from 'react';
import { Token } from 'shared/types/Token';
import useSdk from 'helpers/hooks/useSdk';

const useCheckout = () => {
  const [session, setSession] = useState<Token>();
  const [isExpired, setIsExpired] = useState(false);
  const sdk = useSdk();

  useEffect(() => {
    sdk.composableCommerce.cart.getCheckoutSessionToken().then((res) => {
      if (!res.isError) setSession(res.data);
      else setIsExpired(true);
    });
  }, [sdk]);

  return { session, isExpired };
};

export default useCheckout;
